import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/AuthContext";
import { useI18n } from "@/lib/I18nContext";
import { translateAuthError } from "@/lib/authErrors";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { checkAuth } = useAuth();
  const { t } = useI18n();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const inviteCode = localStorage.getItem("polla_invite_code") || "";
        const r = await api.post("/auth/google/session", {
          session_id: sessionId,
          invite_code: inviteCode,
        });
        localStorage.removeItem("polla_invite_code");
        if (r.data?.session_token) {
          localStorage.setItem("polla_token", r.data.session_token);
        }
        await checkAuth();
        const dest = r.data?.user?.is_special_only ? "/pollas-especiales" : "/perfil";
        navigate(dest, { replace: true, state: { user: r.data.user } });
      } catch (e) {
        const msg = e?.response?.data?.detail;
        if (msg === "INVITE_CODE_REQUIRED") {
          alert(t("auth.googleNewUser"));
        } else if (msg) {
          alert(translateAuthError(msg, t));
        }
        navigate("/login", { replace: true });
      }
    })();
  }, [checkAuth, location.hash, navigate, t]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-black text-white">
      <div className="text-center" data-testid="auth-callback-loading">
        <div className="font-display text-4xl mb-3">{t("auth.callback.title")}</div>
        <div className="text-zinc-400">{t("auth.callback.subtitle")}</div>
      </div>
    </div>
  );
}
